export const post = {
  getList: '/api/post/getList'
};

export const clinics = {
  getList: '/api/ymaps/get-clinics'
};

export const file = {
  delete: '/api/file/s3/delete',
  deleteFolder: '/api/file/s3/delete-folder',
  upload: '/api/file/s3/upload',
  multiUpload: '/api/file/s3/multi-upload'
} as const;

export const publicationEndpoint = {
  update: '/api/publication/update'
};
